import axios from "axios";
import { config } from "../config";
import { authenticate, createResponseErrorHandler, parseDates, stringifyDates } from "./interceptors";

const queryParams = new URLSearchParams(location.search);
const xolaUri = queryParams.get("xolaUri");
export const { apiVersion } = config.xola;

export const api = axios.create({
    baseURL: xolaUri ? `${xolaUri}/api` : `${config.xola.url}/api`,
    headers: { "X-API-VERSION": apiVersion },
});

api.interceptors.request.use(authenticate);
api.interceptors.request.use(stringifyDates);
api.interceptors.response.use(parseDates, createResponseErrorHandler(api));
